var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('jodit-editor',{staticClass:"editor",attrs:{"buttons":_vm.buttons},model:{value:(_vm.contentFromJodit),callback:function ($$v) {_vm.contentFromJodit=$$v},expression:"contentFromJodit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }